import { useQuery } from '@tanstack/react-query'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import { TournamentService } from '@/modules/tournament/api/services'
import type { paths } from '@/schema'

type TournamentsQuery =
	paths['/api/admin/tournaments']['get']['parameters']['query']
type TournamentsResponse =
	paths['/api/admin/tournaments']['get']['responses']['200']['content']['application/json']

const useQueryGetTournaments = (query?: TournamentsQuery) => {
	return useQuery<TournamentsResponse>({
		queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.LIST(query),
		queryFn: () => TournamentService.getTournaments(query),
	})
}

export default useQueryGetTournaments
